import styled from 'styled-components';

const InvestorStyles = styled.div``;

export default InvestorStyles;
